import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Building2, Trash2, Pencil } from "lucide-react";
import AppHeader from "@/components/layout/AppHeader";
import { api } from "@/lib/api";
import InmuebleFormDialog from "@/components/entities/InmuebleFormDialog";

export default function InmueblesPage() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  const load = async () => {
    const { data } = await api.get("/inmuebles");
    setItems(data);
  };
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!window.confirm("¿Eliminar inmueble?")) return;
    await api.delete(`/inmuebles/${id}`);
    toast.success("Inmueble eliminado");
    load();
  };

  return (
    <div className="min-h-screen">
      <AppHeader />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-8">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-3xl font-heading font-extrabold text-slate-900">Inmuebles</h1>
            <p className="text-slate-600 mt-1">Propiedades registradas para reutilizar en documentos.</p>
          </div>
          <button onClick={() => { setEditing(null); setOpen(true); }} className="bm-btn-primary" data-testid="new-inmueble-btn">
            <Plus className="w-4 h-4" /> Nuevo inmueble
          </button>
        </div>

        {items.length === 0 ? (
          <div className="bm-card p-10 text-center" data-testid="inmuebles-empty">
            <Building2 className="w-10 h-10 mx-auto text-slate-300 mb-3" />
            <p className="text-slate-600">Aún no has registrado inmuebles.</p>
          </div>
        ) : (
          <div className="space-y-3">
            {items.map((i) => (
              <div key={i.id} className="bm-card p-4 flex items-center justify-between gap-3" data-testid={`inmueble-row-${i.id}`}>
                <div className="min-w-0">
                  <div className="font-heading font-bold text-slate-900">{i.direccion}</div>
                  <div className="text-xs text-slate-500">
                    {i.ciudad}{i.estado ? `, ${i.estado}` : ""} · {i.tipo_uso}
                    {i.folio_real ? ` · Folio ${i.folio_real}` : ""}
                  </div>
                </div>
                <div className="flex items-center gap-1">
                  <button onClick={() => { setEditing(i); setOpen(true); }} className="p-2 text-slate-500 hover:text-[#2A5C55]" data-testid={`inmueble-edit-${i.id}`}>
                    <Pencil className="w-4 h-4" />
                  </button>
                  <button onClick={() => del(i.id)} className="p-2 text-slate-400 hover:text-red-600" data-testid={`inmueble-delete-${i.id}`}>
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>

      <InmuebleFormDialog open={open} onOpenChange={setOpen} initial={editing} onSaved={load} />
    </div>
  );
}
